import React from 'react'
import {
  Filter,
  List,
  Datagrid,
  TextField,
  TextInput,
  SelectInput,
  ReferenceInput,
} from 'react-admin'

// import { Toolbar } from 'components/List'

// import { FilterApp } from 'components/FilterApp'

const WeeksFilter = (props: any) => {
  return (
    <Filter {...props}>
      <TextInput label="Search" source="title" alwaysOn />
      <ReferenceInput label="Semanas" source="" reference="" allowEmpty>
        <SelectInput optionText="name" />
      </ReferenceInput>
    </Filter>
  )
}

export const ListWeeks = (props: any) => {
  const { staticContext, ...rest } = props
  return (
    <List
      filters={<WeeksFilter />}
      {...rest}
      // actions={
      //   <Toolbar>
      //     <FilterApp
      //       filterPerson={false}
      //       filterCourse={false}
      //       filterLesson={false}
      //       filterUser={false}
      //       filterWeek={true}
      //     />
      //   </Toolbar>
      // }
      data-testid="list"
    >
      <Datagrid rowClick={'edit'}>
        <TextField label="#" source="id" />
        <TextField label="Ordem" source="order" />
        <TextField label="Título" source="title" />
        <TextField label="Slug" source="slug" />
      </Datagrid>
    </List>
  )
}
